// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

// ------------------------------------
// Constants
// ------------------------------------

export const GET_PRODUCTS_BY_MARKET = 'GET_PRODUCTS_BY_MARKET'
export const GET_PRODUCTS_BY_MARKET_FAILED = 'GET_PRODUCTS_BY_MARKET_FAILED'
export const GET_PRODUCTS_BY_MARKET_SUCCEEDED = 'GET_PRODUCTS_BY_MARKET_SUCCEEDED'

export const GET_PRODUCTS_BY_BENEFIT = 'GET_PRODUCTS_BY_BENEFIT'
export const GET_PRODUCTS_BY_BENEFIT_FAILED = 'GET_PRODUCTS_BY_BENEFIT_FAILED'
export const GET_PRODUCTS_BY_BENEFIT_SUCCEEDED = 'GET_PRODUCTS_BY_BENEFIT_SUCCEEDED'

export const FINISH_PURCHASE = 'FINISH_PURCHASE'
export const FINISH_PURCHASE_FAILED = 'FINISH_PURCHASE_FAILED'
export const FINISH_PURCHASE_SUCCEEDED = 'FINISH_PURCHASE_SUCCEEDED'

export const GET_RESULTS_PDF = 'GET_RESULTS_PDF'
export const GET_RESULTS_PDF_FAILED = 'GET_RESULTS_PDF_FAILED'
export const GET_RESULTS_PDF_SUCCEEDED = 'GET_RESULTS_PDF_SUCCEEDED'

export const SET_BEVERAGES = 'SET_BEVERAGES'
export const SET_SNACKS = 'SET_SNACKS'
export const SET_CEREALS = 'SET_CEREALS'
export const SET_DAIRY_PRODUCTS = 'SET_DAIRY_PRODUCTS'
export const SET_READY_TO_EAT = 'SET_READY_TO_EAT'

export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_FINISH_PURCHASE = 'SET_FINISH_PURCHASE'

// ------------------------------------
// Actions
// ------------------------------------

export function getProductsByMarket(token, idMarket, idPais, callback) {
  return {
    type: GET_PRODUCTS_BY_MARKET,
    token,
    idMarket,
    idPais,
    callback
  }
}

export function getProductsByMarketFailed(error) {
  return {
    type: GET_PRODUCTS_BY_MARKET_FAILED,
    error
  }
}

export function getProductsByMarketSucceeded(data) {
  return {
    type: GET_PRODUCTS_BY_MARKET_SUCCEEDED,
    payload: data
  }
}

export function getProductsByBenefit(token, idMarket, callback) {
  return {
    type: GET_PRODUCTS_BY_BENEFIT,
    token,
    idMarket,
    callback
  }
}

export function getProductsByBenefitFailed(error) {
  return {
    type: GET_PRODUCTS_BY_BENEFIT_FAILED,
    error
  }
}

export function getProductsByBenefitSucceeded(data) {
  return {
    type: GET_PRODUCTS_BY_BENEFIT_SUCCEEDED,
    payload: data
  }
}

export function finishPurchase(token, term, callback) {
  return {
    type: FINISH_PURCHASE,
    token,
    term,
    callback
  }
}

export function finishPurchaseFailed(error) {
  return {
    type: FINISH_PURCHASE_FAILED,
    error
  }
}

export function finishPurchaseSucceeded(data) {
  return {
    type: FINISH_PURCHASE_SUCCEEDED,
    payload: data
  }
}

export function getResultsPDF (token, term, callback) {
  return {
    type: GET_RESULTS_PDF,
    token,
    term,
    callback
  }
}

export function getResultsPDFFailed (error) {
  return {
    type: GET_RESULTS_PDF_FAILED,

  }
}

export function getResultsPDFSucceeded () {
  return {
    type: GET_RESULTS_PDF_SUCCEEDED,
  }
}

export function setBeverages(data) {
  return {
    type: SET_BEVERAGES,
    payload: data
  }
}

export function setSnacks(data) {
  return {
    type: SET_SNACKS,
    payload: data
  }
}

export function setCereals(data) {
  return {
    type: SET_CEREALS,
    payload: data
  }
}

export function setDairyProducts(data) {
  return {
    type: SET_DAIRY_PRODUCTS,
    payload: data
  }
}

export function setReadyToEat(data) {
  return {
    type: SET_READY_TO_EAT,
    payload: data
  }
}

export function setProducts(data) {
  return {
    type: SET_PRODUCTS,
    payload: data
  }
}

export function setFinishPurchase(data) {
  return {
    type: SET_FINISH_PURCHASE,
    payload: data
  }
}

export const actions = {
  getProductsByMarket,
  getProductsByMarketFailed,
  getProductsByMarketSucceeded,
  getProductsByBenefit,
  getProductsByBenefitFailed,
  getProductsByBenefitSucceeded,
  finishPurchase,
  finishPurchaseFailed,
  finishPurchaseSucceeded,
  setBeverages,
  setSnacks,
  setCereals,
  setDairyProducts,
  setReadyToEat,
  setProducts,
  setFinishPurchase,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_PRODUCTS_BY_MARKET]: (state, action) => ({
    ...state,
    getProductsByMarketStatus : API_REQUEST_STATUS_LOADING,
    getProductsByMarketError : -1
  }),

  [GET_PRODUCTS_BY_MARKET_FAILED]: (state, action) => ({
    ...state,
    getProductsByMarketStatus : API_REQUEST_STATUS_FAILED,
    getProductsByMarketError : action.error
  }),

  [GET_PRODUCTS_BY_MARKET_SUCCEEDED]: (state, action) => ({
    ...state,
    getProductsByMarketStatus : API_REQUEST_STATUS_SUCCEEDED,
    getProductsByMarketError : -1,
    beverages: action.payload.beverages,
    snacks: action.payload.snacks,
    cereals: action.payload.cereals,
    dairyProducts: action.payload.dairyProducts,
    readyToEat: action.payload.readyToEat
  }),

  [GET_PRODUCTS_BY_BENEFIT]: (state, action) => ({
    ...state,
    getProductsByBenefitStatus : API_REQUEST_STATUS_LOADING,
    getProductsByBenefitError : -1
  }),

  [GET_PRODUCTS_BY_BENEFIT_FAILED]: (state, action) => ({
    ...state,
    getProductsByBenefitStatus : API_REQUEST_STATUS_FAILED,
    getProductsByBenefitError : action.error
  }),

  [GET_PRODUCTS_BY_BENEFIT_SUCCEEDED]: (state, action) => ({
    ...state,
    getProductsByBenefitStatus : API_REQUEST_STATUS_SUCCEEDED,
    getProductsByBenefitError : -1
  }),

  [FINISH_PURCHASE]: (state, action) => ({
    ...state,
    finishPurchaseStatus : API_REQUEST_STATUS_LOADING,
    finishPurchaseError : -1
  }),

  [FINISH_PURCHASE_FAILED]: (state, action) => ({
    ...state,
    finishPurchaseStatus: API_REQUEST_STATUS_FAILED,
    finishPurchaseError: action.error
  }),

  [FINISH_PURCHASE_SUCCEEDED]: (state, action) => ({
    ...state,
    finishPurchaseStatus: API_REQUEST_STATUS_SUCCEEDED,
    finishPurchaseError: -1,
    finishPurchase: action.payload
  }),

  [GET_RESULTS_PDF]: (state, action) => ({
    ...state,
    getResultsPDFStatus : API_REQUEST_STATUS_LOADING,
    getResultsPDFError : -1
  }),

  [GET_RESULTS_PDF_FAILED]: (state, action) => ({
    ...state,
    getResultsPDFStatus: API_REQUEST_STATUS_FAILED,
    getResultsPDFError: action.error
  }),

  [GET_RESULTS_PDF_SUCCEEDED]: (state, action) => ({
    ...state,
    getResultsPDFStatus: API_REQUEST_STATUS_SUCCEEDED,
    getResultsPDFError: -1,
  }),

  [SET_BEVERAGES]: (state, action) => ({
    ...state,
    beverages: action.payload
  }),

  [SET_SNACKS]: (state, action) => ({
    ...state,
    snacks: action.payload
  }),

  [SET_CEREALS]: (state, action) => ({
    ...state,
    cereals: action.payload
  }),

  [SET_DAIRY_PRODUCTS]: (state, action) => ({
    ...state,
    dairyProducts: action.payload,
  }),

  [SET_READY_TO_EAT]: (state, action) => ({
    ...state,
    readyToEat: action.payload
  }),

  [SET_PRODUCTS]: (state, action) => ({
    ...state,
    beverages: action.payload.beverages,
    snacks: action.payload.snacks,
    cereals: action.payload.cereals,
    dairyProducts: action.payload.dairyProducts,
    readyToEat: action.payload.readyToEat
  }),

  [SET_FINISH_PURCHASE]: (state, action) => ({
    ...state,
    finishPurchase: action.payload
  }),

}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  beverages: [],
  snacks: [],
  cereals: [],
  dairyProducts: [],
  readyToEat: [],
  getProductsByMarketStatus : -1,
  getProductsByMarketError : -1,
  finishPurchase: {
    beneficio: '',
    titulo: '',
    calificacion: '',

    subtitulo: '',
    parrafo: '',
    invitacion: ''
  },
  finishPurchaseStatus: -1,
  finishPurchaseError: -1,
  getProductsByBenefitStatus : -1,
  getProductsByBenefitError : -1,
  getResultsPDFStatus : -1,
  getResultsPDFError : -1,
}

export default function productsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/modules/module_products.js